import { Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { GlobalLoader } from './newcomponents/GlobalLoader/GlobalLoader';
import FetchLocalStorageDataByPath from './utils/helper/FetchLocalstorageDataByPath.js';

const AdminRoute = ({ component: Component, element, ...rest }) => {
  const [isFeatureActive, setisFeatureActive] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = sessionStorage.getItem('authorizationToken');
  const isAuthenticated = token && token !== null;
  const { path } = rest;
  const newPath = path.substr(1);

  useEffect(() => {
    getLocalStorageDataFunc();
  }, [path]);

  const getLocalStorageDataFunc = async () => {
    try {
      const fetchedLocalStorageData = FetchLocalStorageDataByPath('system_config', 'features') ?? [];
      const crudsPermissions = FetchLocalStorageDataByPath('system_config', 'adminPanel');
      const crudsPermissionsFound = await crudsPermissions.find((values) => values.path_name === newPath);
      const foundFeature = await fetchedLocalStorageData.find((values) => values.path_name === newPath);

      if (foundFeature) {
        setisFeatureActive((prev) => ({ ...prev, [newPath]: foundFeature.value }));
      } else if (crudsPermissionsFound) {
        setisFeatureActive((prev) => ({ ...prev, [newPath]: crudsPermissionsFound.value }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <GlobalLoader />;
  }

  if (isFeatureActive === null || !isFeatureActive.hasOwnProperty(newPath)) {
    return element;
  }

  if (isFeatureActive['systemconfiguration'] === false) {
    return <Navigate to="/inbasketpage" />;
  }

  if (isFeatureActive[newPath] === true || newPath === 'admin') {
    return element;
  }

  return <Navigate to="/inbasketpage" />;
};

export default AdminRoute;